// extracted by mini-css-extract-plugin
export default {"star-icon":"_1oexg5w","starIcon":"_1oexg5w","rating":"_u1wihp"};